import angular from 'angular'

// Create empty module to contain all HTML templates
export default angular.module('templates', []).name
